import { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
import { SText } from '@setvi/shared/components';

interface AnimatedNumberProps {
  value: number | undefined;
  duration?: number;
  weight?: 'bold' | 'medium' | 'semibold';
  size?: 'xl';
}

const AnimatedNumber = ({
  value,
  duration = 1.2,
  weight = 'bold',
  size = 'xl'
}: AnimatedNumberProps) => {
  const spring = useSpring(0, {
    stiffness: 50,
    damping: 20,
    duration: duration * 1000
  });

  const display = useTransform(spring, current =>
    Math.round(current).toString()
  );

  const [displayValue, setDisplayValue] = useState('0');

  useEffect(() => {
    const unsubscribe = display.onChange(latest => {
      setDisplayValue(latest);
    });

    return () => unsubscribe();
  }, [display]);

  useEffect(() => {
    if (value !== undefined) {
      spring.set(value);
    } else {
      spring.set(0);
    }
  }, [value, spring]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}>
      <SText title={displayValue} weight={weight} size={size} />
    </motion.div>
  );
};

export default AnimatedNumber;
